import { Box, Slider, Typography } from '@mui/material';
import { useAudioPlayer } from '@contexts/AudioPlayerContext';
import { formatTime } from '@utils/time/timeUtils';

export default function AudioProgressBar() {
  const { currentTime, duration, seekTo, currentEpisode } = useAudioPlayer();

  const handleSeekChange = (event, newValue) => {
    if (duration > 0) {
      const newTime = (newValue / 100) * duration;
      seekTo(newTime);
    }
  };

  const progress = duration > 0 ? (currentTime / duration) * 100 : 0;
  const disabled = !currentEpisode || duration === 0;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.5, sm: 1 }, width: '100%', minWidth: 0 }}>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ minWidth: { xs: 36, sm: 45 }, fontSize: { xs: '0.65rem', sm: '0.75rem' } }}
      >
        {formatTime(currentTime)}
      </Typography>

      <Slider
        value={progress}
        onChange={handleSeekChange}
        disabled={disabled}
        size="small"
        aria-label="Playback progress"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          '& .MuiSlider-thumb': {
            width: { xs: 14, sm: 12 },
            height: { xs: 14, sm: 12 }
          }
        }}
      />

      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ minWidth: { xs: 36, sm: 45 }, fontSize: { xs: '0.65rem', sm: '0.75rem' } }}
      >
        {formatTime(duration)}
      </Typography>
    </Box>
  );
}
